module.exports = __webpack_public_path__ + "static/img/strona_002.6ddc776a.jpg";